import { parseBoolean, datesToISO } from "@";

export const searchValuesPayload = (page, pageSize, search) => {
  return {
    page: page,
    pageSize: pageSize,
    searchKey: search.searchKey,
    toTime: datesToISO(search.toDate),
    fromTime: datesToISO(search.fromDate),
    isMessageSent: parseBoolean(search.isMessageSent),
    hasIbanCopied: parseBoolean(search.hasIbanCopied),
    hasLinkClicked: parseBoolean(search.hasLinkClicked),
    hasOrderCompleted: parseBoolean(search.hasOrderCompleted),
  };
};
